import { Tooltip, Typography } from "@mui/material";
import { StyledTableCell } from "../style";
import { useMemo } from "react";

// Virtuoso remounts rows on scroll, so building the formatter per cell means
// one Intl.DateTimeFormat construction per row per scroll pass.
const fullFormat = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "short",
});

export default function DateCell(args) {
  const parsed = useMemo(() => {
    if (!args.content) return null;
    const d = new Date(args.content);
    if (isNaN(d)) return null;
    return {
      short: d.toLocaleDateString(),
      full: fullFormat.format(d),
      iso: d.toISOString(),
    };
  }, [args.content]);

  if (!parsed)
    return (
      <StyledTableCell {...args}>
        <Typography variant="body2" color="textSecondary">
          {args.content}
        </Typography>
      </StyledTableCell>
    );

  return (
    <StyledTableCell {...args}>
      <Tooltip title={parsed.full} arrow placement="top" enterDelay={300}>
        <Typography
          component="time"
          dateTime={parsed.iso}
          variant="body2"
          color="textSecondary"
          sx={{ cursor: "help" }}
        >
          {parsed.short}
        </Typography>
      </Tooltip>
    </StyledTableCell>
  );
}
